import { useContext } from "react";
import { LoginContext } from "../../context/LoginContext";
import { USER_ROLES } from "../../auth/session";

export default function RegistrationOrigin({ value }) {
  const { LoggedUser } = useContext(LoginContext);
  if (LoggedUser?.role !== USER_ROLES.ADMIN) return null;
  const label = value === 0 ? "Manual" : value === 1 ? "Link externo" : "Não informada";
  return (
    <div className="registration-origin">
      <span>Origem do cadastro</span>{" "}
      <strong>{label}</strong>
    </div>
  );
}
